var map = {
	"./ArrowIcon.vue": "7034",
	"./BackIcon.vue": "421c",
	"./CheckedIcon.vue": "2aa5",
	"./ClockIcon.vue": "e40c",
	"./CopyIcon.vue": "0154",
	"./CouponIcon.vue": "10e9",
	"./CrossIcon.vue": "e47f",
	"./DashboardIcon.vue": "ddb4",
	"./DownloadIcon.vue": "fbc1",
	"./EditIcon.vue": "cc00",
	"./FileExcelIcon.vue": "59ab",
	"./FileIcon.vue": "6a17",
	"./FilePdfIcon.vue": "7d83",
	"./FileVideoIcon.vue": "bf41",
	"./FileWordIcon.vue": "5894",
	"./FolderIcon.vue": "4efa",
	"./FullscreenIcon.vue": "ef3a",
	"./InfoIcon.vue": "bcd1",
	"./LinkedIcon.vue": "c83f",
	"./LockClosedIcon.vue": "2172",
	"./LockIcon.vue": "a250",
	"./LogoutIcon.vue": "4c7c",
	"./MyCourseIcon.vue": "6201",
	"./PauseIcon.vue": "c47e",
	"./PlayIcon.vue": "5f9a",
	"./ProfileIcon.vue": "75b5",
	"./SettingsIcon.vue": "c09f",
	"./SimpleArrowIcon.vue": "8e76",
	"./StarIcon.vue": "e57b",
	"./SuccessIcon.vue": "b06c",
	"./TrashIcon.vue": "6e7a",
	"./UploadIcon.vue": "08e2",
	"./VolumeCanceledIcon.vue": "fb44",
	"./VolumeFullIcon.vue": "e9a4",
	"./VolumeIcon.vue": "14a2",
	"./VolumeSmallIcon.vue": "9c52",
	"./ZoomInIcon.vue": "e99d",
	"./ZoomOutIcon.vue": "032d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9cd1";